import { Component, OnDestroy } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { AuthService } from './providers/authentication/auth.service';
import { SSO } from './providers/nom-web-services-json/sso';
import { SSOService } from './providers/authentication/sso/sso.service';
import 'rxjs/add/operator/pairwise';

declare var external: any

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnDestroy {
    private routeSub: Subscription;

    constructor(
        private activatedRoute: ActivatedRoute,
        private location: Location,
        private router: Router,
        private authService: AuthService,
        private sso: SSO,
        private ssoService: SSOService
    ) {
        this.routeSub = this.activatedRoute.queryParams.subscribe(this.paramsChanged.bind(this));
    }

    public ngOnDestroy() {
        if (this.routeSub) this.routeSub.unsubscribe();
    }

    private async paramsChanged(p: Params) {
        const matchToken = {
            "GOOGLE": /id_token=(.*)&authuser/,
            "MICROSOFTAZURE": /id_token=(.*)&state/,
            "MICROSOFTLIVE": /id_token=(.*)&state/,
            "OKTA": /id_token=(.*)&state/,
            "ONELOGIN": /access_token=(.*)&expires_in/
        };

        const providerName = localStorage.getItem("providerName");
        const tokenMatches = window.location.href.match(matchToken[providerName]);
        const idToken = (tokenMatches && (tokenMatches.length > 1)) ? tokenMatches[1] : null;
        
        if (idToken && !this.activatedRoute.snapshot.params["success"]) {
            let redirectUri = localStorage.getItem("redirectUri");
            if (redirectUri) {
                // Web
                if (redirectUri.indexOf("?") >= 0) {
                    redirectUri += "&";
                } else {
                    redirectUri += "?";
                }
                redirectUri += "providerName=" + encodeURIComponent(providerName) + "&idToken=" + encodeURIComponent(idToken);
                window.location.href = redirectUri;
            } else {
                // Desktop
                external.receiveJWT(idToken, providerName)
            }
        } else {
            try {
                this.authService.redirectUri = p["redirectUri"];
                if (this.authService.redirectUri) localStorage.setItem("redirectUri", this.authService.redirectUri);
                this.authService.providerName = p["providerName"];
                if (this.authService.providerName) localStorage.setItem("providerName", this.authService.providerName);

                if (this.authService.providerName) {
                    this.ssoService.ssoSettings = (await this.sso.getSSOSettings()).data;

                    const action = p["action"] ? p["action"].toLowerCase() : "";
                    switch (action) {
                        default:
                            this.authService.authenticate();
                            break;
                    }
                }
            } catch (e) {
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts